angular.module('pulseApp').config(function($stateProvider, $urlRouterProvider) {
    
    $stateProvider.state('addProvider', {
        url: '/addProvider',
        controller: 'AddProviderCtrl as vm',
        templateUrl: 'app/view/addProvider/addProvider.html',
    });    

}).controller('AddProviderCtrl', function ($scope, $state, $stateParams, $firebaseArray) {
    var vm = this;

    vm.provider = {
        Hours: [
            {Day: "Monday"},
            {Day: "Tuesday"},
            {Day: "Wednesday"},
            {Day: "Thursday"},
            {Day: "Friday"},
            {Day: "Saturday"},
            {Day: "Sunday"}
    ],
    City: 'SEA',
    Category: 'F'
    }



    
    var ref = firebase.database().ref('Providers');
    // download the data into a local object
    vm.data = $firebaseArray(ref);
    vm.addProvider = function() {
     vm.data.$add(vm.provider).then(function(ref) {
            $state.go('results', { id: 0 });
          });
      };
    var destroy = $scope.$on("$destroy", function () {
        //Cleanup anything that would persist beyond destruction, including $on/$watch
        destroy();
    });
});